import { CSSProperties } from "react";

export default function mergeStyles(
  ...styles: Array<undefined | CSSProperties>
): CSSProperties {
  // @ts-ignore
  return styles.reduce(
    // tslint:disable-next-line:prefer-object-spread
    (result, current) => Object.assign(result, current || {}),
    {}
  );
}
